import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  Card,
  CardBody,
} from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ChatBotLiveChat from '../ChatBotLiveChat';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import ChatBotFeatures from '../ChatbotFeatures';
import WelcomeMessage from '../WelcomeMessage';
import AIInstructionsModule from './AIInstructionsModule';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import {
  API_Whatsapp_Integration,
  gAPI_Property_List_By_Group,
  gAPI_Internal_Property_By_Id,
  dAPI_Delete_Ingetration,
  dAPI_Delete_PhoneIngetration_Group,
  API_Whatsapp_Integration_Group,
} from '../../../../../../constants/APIs';
import { NavLink } from 'react-router-dom';
import {
  faComment,
  faExternalLinkAlt,
  faHome,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Example from '../Example';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  putAPI_Update_Ingetration,
  gAPI_Ingetration,
} from '../../../../../../constants/APIs';
import WhatsAppInfo from '../WhatsAppInfo';
import LiveChat from '../LiveChat';
import Features from './Features';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import AIInstructorModule from './AIInstructionsModule';
import { faFileText } from '@fortawesome/free-regular-svg-icons';

function WhatsappIntegrationList({ match, history, propertyId, locale }) {
  const integrationId = match.params.id;
  const [integration, setIntegration] = useState();
  const [allProperties, setAllProperties] = useState([]);
  const [propertyVisible, setPropertyVisible] = useState(true);
  const [liveChatVisible, setLiveChatVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [serviceUrlVisible, setServiceUrlVisible] = useState(false);
  const [featuresVisible, setFeaturesVisible] = useState(false);
  const [propertyData, setPropertyData] = useState([]);
  const [serviceURLEndpoint, setServiceURLEndpoint] = useState('');
  const [linkCopied, setLinkCopied] = useState(false);
  const [aiInstructionsVisible, setAIInstructionsVisible] = useState(false);
  const [welcomeMessageVisible, setWelcomeMessageVisible] = useState(false);

  const property = () => {
    setPropertyVisible(true);
    setLiveChatVisible(false);
    setServiceUrlVisible(false);
    setFeaturesVisible(false);
    setAIInstructionsVisible(false);
    setWelcomeMessageVisible(false);
  };

  const setLiveChat = () => {
    setPropertyVisible(false);
    setLiveChatVisible(true);
    setServiceUrlVisible(false);
    setFeaturesVisible(false);
    setAIInstructionsVisible(false);
    setWelcomeMessageVisible(false);
  };

  const setServiceUrl = () => {
    setPropertyVisible(false);
    setLiveChatVisible(false);
    setServiceUrlVisible(true);
    setAIInstructionsVisible(false);
    setFeaturesVisible(false);
    setWelcomeMessageVisible(false);
  };

  const features = () => {
    setPropertyVisible(false);
    setLiveChatVisible(false);
    setServiceUrlVisible(false);
    setFeaturesVisible(true);
    setAIInstructionsVisible(false);
    setWelcomeMessageVisible(false);
  };
  const aiInstructions = () => {
    setPropertyVisible(false);
    setLiveChatVisible(false);
    setServiceUrlVisible(false);
    setFeaturesVisible(false);
    setAIInstructionsVisible(true);
    setWelcomeMessageVisible(false);
  };
  const welcomeMessage = () => {
    setPropertyVisible(false);
    setLiveChatVisible(false);
    setServiceUrlVisible(false);
    setFeaturesVisible(false);
    setAIInstructionsVisible(false);
    setWelcomeMessageVisible(true);
  };
  useEffect(() => {
    LoadIntegration();
    const url =
      process.env.REACT_APP_CHAT_API +
      `/whatsapp?iid=${integrationId}&groupId=${getGroupID()}`;
    setServiceURLEndpoint(url);
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    }).then((res) => {
      console.log(res.data);
      setPropertyData(res.data);
    });
  }, [integrationId, propertyId]);
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllProperties(res.data);
    });
  }, []);
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const LoadIntegration = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_Whatsapp_Integration}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        console.log(res.data);
        setIntegration(res.data);
      })
      .catch((err) => console.log('err', err));
  };
  const updateModel = integration
    ? {
      name: integration.name,
      // propertyIds: integration.properties[0],
      propertyIds: Array.isArray(integration?.properties)
        ? [...integration.properties]
        : [],
      defaultLanguage: 'en-US',
      sessionTimeoutInSeconds: integration.sessionTimeoutInSeconds,
      // phoneNumber: integration.channelDetails.phoneNumber,
      // accountSID: integration.channelDetails.accountSID,
      // authToken: integration.channelDetails.authToken,
      phoneNumber: integration?.channelDetails?.phoneNumber ?? null,
      accountSID: integration?.channelDetails?.accountSID || '',
      authToken: integration?.channelDetails?.authToken || '',
      liveChatSetting: integration.liveChat,
      botSettings: { ...integration.botSettings },
    }
    : null;
  const saveIntegration = (data) => {
    const { list, name, liveChat, botSetting } = data;
    if (list) {
      updateModel.propertyIds = Array.isArray(list) ? list : [list];
    }
    if (name) {
      updateModel.name = name;
    }
    if (liveChat) {
      updateModel.liveChatSetting = Array.isArray(liveChat)
        ? liveChat[0] || null
        : liveChat;
      updateModel.liveChatSettingsList = Array.isArray(liveChat)
        ? liveChat
        : [liveChat];
    }
    if (botSetting) {
      updateModel.botSettings = botSetting;
    }
    //console.log('update', liveChat, updateModel, botSetting);
    AxiosAPI({
      method: 'get',
      url: `${API_Whatsapp_Integration_Group}?phone_number=${integration?.channelDetails?.phoneNumber || ''}`,
    }).then((res) => {
      let forceRefresh = {
        updater: 'Dashboard',
        refresh: true,
        phoneNumber: integration.channelDetails.phoneNumber,
      };
      AxiosAPI({
        method: 'put',
        url: `${API_Whatsapp_Integration}/${integrationId}?group_id=${getGroupID()}`,
        data: updateModel,
      }).then(() =>
        AxiosAPI({
          method: 'put',
          url: `${API_Whatsapp_Integration_Group}/${res.data.id}`,
          data: forceRefresh,
        }).then(() => {
          LoadIntegration();
          NotificationManager.success(
            '',
            liveChat
              ? 'Live chat settings updated successfully'
              : 'Integration updated successfully',
            3000,
            null,
            null,
            'success'
          );
        })
      );
    });
  };
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integrationId}/?group_id=${getGroupID()}`,
    }).then((res) => {
      let updateRequest = {
        updater: 'Dashboard',
      };
      AxiosAPI({
        method: 'delete',
        url: `${API_Whatsapp_Integration_Group}/${integration?.channelDetails?.phoneNumber || ''}`,
        data: updateRequest,
      })
        .then((result) => {
          toggle();
          LoadIntegration();
        })
        .catch((err) => {
          console.log('err', err);
        });
    });
  };
  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  // const saveLiveChatSettings = (data) => {
  //     updateModel.liveChatSettingsList = data.liveChatSettings;
  //     console.log(JSON.stringify(updateModel));
  //     AxiosAPI({
  //         method: 'put',
  //         url: `${putAPI_Update_Ingetration}/${integration.id}?group_id=${getGroupID()}`,
  //         data: updateModel,
  //     })
  //         .catch((err) => console.error(err))
  //         .then(() => {
  //             NotificationManager.success(
  //                 "",
  //                 "Live chat settings update successfully",
  //                 3000,
  //                 null,
  //                 null,
  //                 "success"
  //             );
  //             AxiosAPI({
  //                 method: 'get',
  //                 url: `${gAPI_Ingetration}/${integrationId}/dashboard?group_id=${getGroupID()}`,
  //             })
  //                 .then((res) => {
  //                     setIntegration(res.data);
  //                 })
  //         });
  // };
  // const saveLiveChatSettings = (data) => {
  //     // updateModel.liveChatSettingsList = data.liveChatSettings;
  //     updateModel.liveChatSetting = data.liveChatSettings?.[0] || null;
  //     updateModel.liveChatSettingsList = data.liveChatSettings || [];
  //     updateModel.phoneNumber = integration?.channelDetails?.phoneNumber || "";
  //     updateModel.accountSID = integration?.channelDetails?.accountSID || "";
  //     updateModel.authToken = integration?.channelDetails?.authToken || "";

  //     console.log("FINAL PAYLOAD", updateModel);

  //     AxiosAPI({
  //         method: 'put',
  //         url: `${putAPI_Update_Ingetration}/${integration.id}?group_id=${getGroupID()}`,
  //         data: updateModel,
  //     })
  //         .catch((err) => console.error(err))
  //         .then(() => {
  //             NotificationManager.success(
  //                 "",
  //                 "Live chat settings update successfully",
  //                 3000,
  //                 null,
  //                 null,
  //                 "success"
  //             );

  //             AxiosAPI({
  //                 method: 'get',
  //                 url: `${gAPI_Ingetration}/${integrationId}/dashboard?group_id=${getGroupID()}`,
  //             }).then((res) => {
  //                 setIntegration(res.data);
  //             });
  //         });
  // };

  return (
    <Fragment>
      {integration ? (
        <Fragment>
          <Row>
            <Colxx md="12" sm="12" lg="12" xxs="12">
              <NavLink to={{ pathname: '/app/pages/integration/channels' }}>
                <h1 className="iconsminds-back" />
              </NavLink>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" md="6" className="mb-4">
              <Card>
                <CardBody>
                  <div
                    className={`mb-3 integration ${propertyVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-hotel`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => property()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            <IntlMessages id="integration.select_properties" />
                          </p>
                          <p className="mb-4 text-small">
                            <IntlMessages id="integration.select_properties_enabled" />
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${featuresVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon simple-icon-game-controller`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => features()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Features
                          </p>
                          <p className="mb-4 text-small">
                            Select the features you want enabled on the website
                            chat widget
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${welcomeMessageVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faHome} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => welcomeMessage()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Welcome Message
                          </p>
                          <p className="mb-4 text-small">
                            This is the very first message that shows up when
                            customer starts a chat.
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  {/* <div
                    className={`mb-3 integration ${
                      aiInstructionsVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faFileText} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => aiInstructions()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            AI Instructions
                          </p>
                          <p className="mb-4 text-small">
                            This is the very first message that shows up when
                            customer starts a chat.
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div> */}
                  <div
                    className={`mb-3 integration ${liveChatVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faComment} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setLiveChat()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Live Chat
                          </p>
                          <p className="mb-4 text-small">
                            Select the settings for the live chat
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min  iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${serviceUrlVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon
                        icon={faExternalLinkAlt}
                        className="fa"
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setServiceUrl()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Service Endpoint Url
                          </p>
                          <p className="mb-4 text-small">
                            Copy your Service Endpoint Url
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min  iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={toggle}
                    >
                      Archive
                    </Button>

                    <Separator />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-4">
              {propertyVisible && (
                <Fragment>
                  <WhatsAppInfo
                    integration={integration}
                    integrationProperties={integration.properties}
                    // integrationProperties={integration?.properties || []}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" /> */}
                </Fragment>
              )}
              {welcomeMessageVisible && (
                <Fragment>
                  <WelcomeMessage
                    channel="WhatsApp"
                    integration={integration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                    botSettings={integration.botSettings}
                  />
                </Fragment>
              )}
              {featuresVisible && (
                <Fragment>
                  <ChatBotFeatures
                    integration={integration}
                    channel="WhatsApp"
                    integrationProperties={integration.properties}
                    // integrationProperties={integration?.properties || []}
                    allProperties={allProperties.filter((f) =>
                      (integration?.properties || []).includes(f.id)
                    )}
                    // botSettings={integration?.botSettings || {}}
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                    locale={locale}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/properties.png" /> */}
                </Fragment>
              )}
              {liveChatVisible && (
                <Fragment>
                  <ChatBotLiveChat
                    liveChatSettings={integration?.liveChatSettingsList || []}
                    propertyData={propertyData}
                    saveIntegration={saveIntegration}
                    integration={integration}
                    integrationProperties={integration.properties}
                    // integrationProperties={integration?.properties || []}
                    allProperties={allProperties.filter((f) =>
                      (integration?.properties || []).includes(f.id)
                    )}
                    // botSettings={integration?.botSettings || {}}
                    botSettings={integration.botSettings}
                    locale={locale}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/languages.png" /> */}
                </Fragment>
              )}
              {serviceUrlVisible && (
                <Fragment>
                  <Card>
                    <CardBody>
                      <div className="text-center mb-2">
                        <h6>Service Endpoint Url</h6>
                      </div>
                      <Separator className="mb-3" />
                      <Card className="m-4">
                        <Colxx xxs="12" className="py-3">
                          <div className="code-snippet my-3">
                            {serviceURLEndpoint}
                          </div>
                        </Colxx>
                      </Card>
                      <Separator className="mb-3" />
                      <div className="text-center">
                        <CopyToClipboard text={serviceURLEndpoint} onCopy={() => setLinkCopied(true)}>
                          <Button color="success" size="xs" className="my-2">
                            Copy the URL
                          </Button>
                        </CopyToClipboard>
                        {linkCopied ? <h6>Copied</h6> : null}
                      </div>
                    </CardBody>
                  </Card>
                </Fragment>
              )}
              {aiInstructionsVisible && (
                <Fragment>
                  <AIInstructionsModule
                    saveIntegration={saveIntegration}
                    botSettings={integration.botSettings}
                    allProperties={allProperties}
                  />
                </Fragment>
              )}
            </Colxx>
          </Row>
        </Fragment>
      ) : null}
      {generateDeleteButton()}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(
  connect(mapStateToProps, {})(WhatsappIntegrationList)
);
